import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { WHATSAPP_NUMBER } from 'src/app/variables';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  constructor(private router :Router) { }

  ngOnInit(): void {
  }

  pushToAdmin() {
    this.router.navigate(["/admin/products"])
  }

  get getNro() {
    return WHATSAPP_NUMBER.substring(4);
  }

}
